import React, { useState, useEffect } from 'react';
import styles from './TransactionTab.module.css';
import { useFirestoreDoc } from '../../../hooks/useFirestoreDoc';
import { useTranslation } from 'react-i18next';
import { HiCurrencyDollar, HiPaperAirplane, HiCreditCard, HiUser, HiClock, HiArrowPath } from 'react-icons/hi2';
import { useNotifications } from "../../../utils/NotificationContext/NotificationContext";
import { useAuth } from "../../../utils/AuthContext/authcontext";
import UserSearchGeneric from '../../../utils/UserSearchGeneric/UserSearchGeneric';
import Button from '../../ui/Button';

export default function TransactionTab({ user, onSend, onBuy }) {
  const [sendAmount, setSendAmount] = useState(0);
  const [recipient, setRecipient] = useState(null);
  const [buyAmount, setBuyAmount] = useState(0);
  const [isSending, setIsSending] = useState(false);
  const [cachedResults, setCachedResults] = useState({});
  const { docData, loading, error } = useFirestoreDoc(`users/${user?.uid}`);
  const {listenToWallet, listenToTransactions, sendRatioCoin } = useAuth(); 
   const [wallet, setWallet] = useState(null);
   const [isnextUpdate, setShowNextUpdate] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [nextUpdate, setNextUpdate] = useState(null); 
  const { t } = useTranslation();
  const { notify } = useNotifications();

   const toFixed = (n, fixed) => ~~(Math.pow(10, fixed) * n) / Math.pow(10, fixed);

 useEffect(() => {
    const unsubWallet = listenToWallet((data) => {
      setWallet(data);
	  if(data?.pendingTransaction?.failed && isSending == true) {
		setIsSending(false);
		notify('error', data?.pendingTransaction?.failed);
	  }
	  else if(data?.pendingTransaction == undefined  && isSending == true) {
		setIsSending(false);
	  }
      if (data?.balancelastUpdated) {
        const lastUpdated = new Date(data.balancelastUpdated.toDate
          ? data.balancelastUpdated.toDate()
          : data.balancelastUpdated
        );
        const next = new Date(lastUpdated.getTime() + 5 * 60 * 1000);
        setNextUpdate(next);
      }
    });

    const unsubTx = listenToTransactions((transactions) => {
	
		setTransactions(transactions);
	});
    return () => {
      unsubWallet();
      unsubTx();
    };
  }, [isSending]);
  
  const handleSend = () => {
    if (!recipient || !sendAmount || isNaN(sendAmount) || Number(sendAmount) <= 0) {
      notify('error', t('transaction.invalidSend'));
      return;
    }

    if (wallet?.balanceDirty == true) {
      notify('info', t('transaction.outstandingtransac'));
      return;
    }	

	
	setIsSending(true);
    sendRatioCoin(recipient.id, parseFloat(sendAmount));
    setSendAmount('');
    setRecipient(null);

  };

  const handleBuy = () => {
    if (!buyAmount || isNaN(buyAmount) || Number(buyAmount) <= 0) {
      notify('error', t('transaction.invalidBuy'));
      return;
    }
    onBuy(parseFloat(buyAmount));
    setBuyAmount('');
  };

  if (loading) return <div className={styles.message}>{t('transaction.loading')}</div>;
  if (error) return <div className={styles.error}>{t('transaction.error', { error: error.message })}</div>;

  return (
	<div className={styles.wrapper}>
	<div className={styles.background}></div>
	<div className={styles.card}>
      <h3 className={styles.heading}>{t('transaction.title')}</h3>
      <p className={styles.summary}>{t('transaction.summary')}</p>

      <div className={styles.balanceCard}>
        <HiCurrencyDollar className={styles.iconLarge} />
        <div className={styles.balanceValue}>{toFixed(docData.ratioCoin, 5) ?? 0} RTC</div>
        <div className={styles.balanceLabel}>{t('transaction.currentBalance')}</div>
		{wallet?.balancelastUpdated != undefined ? <><div className={styles.balanceLabel}>
		<HiClock/> Last updated: {new Date(wallet?.balancelastUpdated?.toDate ? wallet?.balancelastUpdated?.toDate() : wallet?.balancelastUpdated).toLocaleString()}
		</div> 
		{wallet?.balanceDirty == true && <div className={styles.balanceLabel}>
           <HiArrowPath /> {t('transaction.transprogress')}
            </div>}</>: <> </>}
      </div>

      <div className={styles.actionSection}>
        <h4>{t('transaction.sendTitle')}</h4>
		<UserSearchGeneric singleSearch={true}
			cache={cachedResults}
			setCache={setCachedResults}
			currentUser={user}           // current logged-in user object
			onSelect={user => setRecipient(user)}
			onCancel={() => {setRecipient(null)}}/>
        <div className={styles.inputGroup}>
          <HiUser className={styles.inputIcon} />
          <input readOnly placeholder={t('transaction.recipient')} value={recipient != null ? recipient?.username : ''} onChange={e => setRecipient(e.target.value)} />
        </div>
        <div className={styles.inputGroup}>
          <HiCurrencyDollar className={styles.inputIcon} />
          <input type="number" placeholder={t('transaction.amount')} value={parseFloat(sendAmount).toFixed(2)} onChange={e => setSendAmount(e.target.value < 0 ? 0 : e.target.value )} />
        </div>
        <Button variant={'secondary'} className={styles.actionBtn} onClick={handleSend} disabled={isSending}><HiPaperAirplane /> {t('transaction.sendBtn')} {isSending == true ? <div className={styles.spinner}></div> : <></>}</Button>
      </div>

      <div className={styles.actionSection}>
        <h4>{t('transaction.buyTitle')}</h4>
        <div className={styles.inputGroup}>
          <HiCurrencyDollar className={styles.inputIcon} />
          <input type="number" placeholder={t('transaction.buyAmount')} value={parseFloat(buyAmount).toFixed(2)} onChange={e => setBuyAmount(e.target.value < 0 ? 0 : e.target.value )} />
        </div>
        {/*<Button className={styles.actionBtn} onClick={handleBuy}><HiCreditCard /> {t('transaction.buyBtn')}</Button>*/}
		<div className={styles.balanceLabel}>Coming soon...</div>
      </div>
    </div>
	</div>
  );
}

